/// <amd-module name="VSSUI/Registration/MessageBarRegistration" />
import { VssComponent } from "VSS/Platform/Layout";
import { MessageBar } from "../MessageBar";

VssComponent.register("messageBar", MessageBar);
